import { createContext } from 'react'
import { CreativeContext, defaultCreativeContext } from './CreativeContext.types'

export const creativeContext = createContext<CreativeContext>(defaultCreativeContext)
